import React from 'react';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  padding?: 'none' | 'sm' | 'md' | 'lg';
  shadow?: 'none' | 'sm' | 'md' | 'lg';
}
export default function Card({
  children,
  className = '',
  padding = 'md',
  shadow = 'md'
}: CardProps) {
  const paddingStyles = {
    none: '',
    sm: 'p-3',
    md: 'p-5',
    lg: 'p-8'
  };
  const shadowStyles = {
    none: '',
    sm: 'shadow-sm',
    md: 'shadow',
    lg: 'shadow-lg'
  };
  return <div className={`bg-white rounded-lg ${paddingStyles[padding]} ${shadowStyles[shadow]} ${className}`} data-id="element-107">
      {children}
    </div>;
}